import React from "react";
import PropTypes from "prop-types";
import ExternalLayout from "../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../customComponents/RenderPage/RenderPage";
import Strip from "../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../customComponents/SEO/SEOComponent";
import HackBanner from "./Banner/HackBanner";
import Registers from "./Banner/RegisterButtons";
import About from "./Hack4ttsAbout";
import Challenge from "./Hack4ttsChallenge";
import Timeline from "./Hack4ttsTimeline";
import Participate from "./Hack4ttToParticipate";
import Evaluation from "./Hack4ttsEvaluation";
import Resources from "./Hack4ttsResources";
import Faqs from "./Hack4ttsFaqs";
import FooterHack4TTS from "./Hack4ttsFooter";

const Hack4ttsInfo = (props) => {
    const [width] = useWindowSize();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return(
        <ExternalLayout>
      <RenderPage
        id="tst-Hack4TTS"
        className={`render px-0 ${
          props.isClassName ? "render-page " : "min-height-auto"
        }`}
        containerType="container-fluid"
      >
       <SEOComponent
          title="Voice Tech for All"
          keywords="SYnthesizing SPeech in INdian languages"
          description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
          siteUrl="/Hack4TTS" />
                <HackBanner />
        <Strip
          id="tst-Hack4TTS"
          className="strip strip-no-padding"
          containerType="container"
        >
          <div>
            <Registers />

             <About section_id="about" />

             <Challenge section_id="problem" />

             <Timeline section_id="timeline" />

             <Participate section_id="participate" />

             <Evaluation section_id="evaluation" />

             <Resources section_id="resources" />

             <Faqs section_id="faqs" />

              <FooterHack4TTS section_id="footerhack4tts" />
          </div>

            {/* <div className="mx-0  pt-5">  
                <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Hack4TTS</h5>
                    <div className="mx-0 mb-5 pb-5">
                        Hello World!
                    </div>
            </div> */}

</Strip>
</RenderPage>
</ExternalLayout>
);
};
Hack4ttsInfo.defaultProps = {
  isClassName: true,
};
Hack4ttsInfo.propTypes = {
  isClassName: PropTypes.bool,
};
export default Hack4ttsInfo;